// Decorative SVG inspired by the v04 PDF proposal:
// radiating sunburst + concentric circles + small gear-like dots.
// Pure CSS-friendly, scales perfectly, looks crisp on any size.

const Sunburst = ({ className = "", color = "#FFFFFF", strokeWidth = 1.5 }) => {
  // 36 rays
  const rays = Array.from({ length: 36 }, (_, i) => {
    const angle = (i * 360) / 36;
    const inner = i % 3 === 0 ? 100 : 110;
    const outer = i % 6 === 0 ? 230 : i % 2 === 0 ? 205 : 180;
    const rad = (angle * Math.PI) / 180;
    const x1 = 250 + Math.cos(rad) * inner;
    const y1 = 250 + Math.sin(rad) * inner;
    const x2 = 250 + Math.cos(rad) * outer;
    const y2 = 250 + Math.sin(rad) * outer;
    return { x1, y1, x2, y2, key: i };
  });

  const dots = Array.from({ length: 12 }, (_, i) => {
    const angle = (i * 360) / 12 + 15;
    const r = 145;
    const rad = (angle * Math.PI) / 180;
    return {
      cx: 250 + Math.cos(rad) * r,
      cy: 250 + Math.sin(rad) * r,
      key: i,
    };
  });

  return (
    <svg
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Concentric circles */}
      <circle cx="250" cy="250" r="60" fill="none" stroke={color} strokeWidth={strokeWidth} opacity="0.7" />
      <circle cx="250" cy="250" r="90" fill="none" stroke={color} strokeWidth={strokeWidth} opacity="0.5" />
      <circle cx="250" cy="250" r="125" fill="none" stroke={color} strokeWidth={strokeWidth} opacity="0.4" strokeDasharray="2 6" />
      <circle cx="250" cy="250" r="160" fill="none" stroke={color} strokeWidth={strokeWidth} opacity="0.3" />

      {/* Small orbit dots */}
      {dots.map((d) => (
        <circle key={d.key} cx={d.cx} cy={d.cy} r="3" fill={color} opacity="0.8" />
      ))}

      {/* Rays */}
      <g opacity="0.9">
        {rays.map((r) => (
          <line
            key={r.key}
            x1={r.x1}
            y1={r.y1}
            x2={r.x2}
            y2={r.y2}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            opacity={r.key % 6 === 0 ? 1 : 0.55}
          />
        ))}
      </g>

      {/* Center solid mark — references the C2 logo dot */}
      <circle cx="250" cy="250" r="14" fill={color} />
      <circle cx="250" cy="250" r="28" fill="none" stroke={color} strokeWidth={strokeWidth * 1.5} />
    </svg>
  );
};

export default Sunburst;
